import React, { useState, useRef } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button, TextField, Select, MenuItem, Box, InputLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FontAwesomeDuoToneStyle } from '../../fontawesome';

const EMPTY_PROJECT_TYPE_FILTER_FALLBACK_VALUE = -1;

const ModernisationsFilterButton = ({ 
    projectTypes = [],
    onChange = (filter) => {},
    useIconStyle = true
}) => {
    const [t,] = useTranslation();
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const [filterValues, setFilterValues] = useState({
        projectTypeId: EMPTY_PROJECT_TYPE_FILTER_FALLBACK_VALUE,
        text: ''
    });

    const filter = useRef({
        projectTypeId: null,
        text: filterValues.text
    });

    const updateFilter = () => {
        filter.current = { 
            projectTypeId: filterValues.projectTypeId !== EMPTY_PROJECT_TYPE_FILTER_FALLBACK_VALUE ? filterValues.projectTypeId : null,
            text: filterValues.text
        };

        onChange(filter.current);
        setDialogIsOpen(false);
    };

    const cancelFilter = async () => {
        const defaultFilterValues = {
            projectTypeId: EMPTY_PROJECT_TYPE_FILTER_FALLBACK_VALUE,
            text: ''
        };

        setFilterValues(defaultFilterValues);

        filter.current = {
            ...defaultFilterValues,
            projectTypeId: filterValues.projectTypeId !== EMPTY_PROJECT_TYPE_FILTER_FALLBACK_VALUE ? filterValues.projectTypeId : null
        };

        onChange(filter.current);
        setDialogIsOpen(false);
    };

    return (
        <>
            <button onClick={() => setDialogIsOpen(true)} className="default-link">
                <FontAwesomeIcon icon={["fad", "sliders-v-square"]} size="2x" style={useIconStyle ? FontAwesomeDuoToneStyle : null} />
            </button>
            <Dialog
                open={dialogIsOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{t("Filter")}</DialogTitle>
                <DialogContent id="alert-dialog-description">
                    <Box>
                        <InputLabel htmlFor='modernisation-filter-text'>{t("FilterValue")}</InputLabel>
                        <TextField value={filterValues.text} fullWidth inputProps={{ id: 'modernisation-filter-text' }}
                            onChange={(e) => setFilterValues(currentFilters => ({ ...currentFilters, text: e.target.value }))} style={{ margin: 5 }} />
                    </Box>
                    <Box style={{marginTop: 10}}>
                        <InputLabel htmlFor='modernisation-filter-projectype'>{t('ProjectType')}</InputLabel>
                        <Select value={filterValues.projectTypeId} fullWidth inputProps={{ id: 'modernisation-filter-projecttype' }} style={{ margin: 5 }}
                            onChange={(e) => setFilterValues(currentFilters => ({ ...currentFilters, projectTypeId: e.target.value }))} >
                            <MenuItem key='' value={EMPTY_PROJECT_TYPE_FILTER_FALLBACK_VALUE}>{t('SelectionPlaceholder')}</MenuItem>
                            {projectTypes.map(x => (<MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>))}
                        </Select>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={cancelFilter}>{t("Cancel")}</Button>
                    <Button color="primary" onClick={updateFilter} autoFocus>{t("Ok")}</Button>
                </DialogActions>
            </Dialog>
        </>
    );

};

export default ModernisationsFilterButton;